import { render, staticRenderFns } from "./TimeoffSidebarItem.vue?vue&type=template&id=15e1c538&lang=html&"
import script from "./TimeoffSidebarItem.vue?vue&type=script&lang=js&"
export * from "./TimeoffSidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports